// codegen:start {preset: barrel, include: './lib/*.{ts,tsx}', exclude: './lib/*.{test,spec}.{ts,tsx}'}
export * from './lib/block-data-provider'; // codegen:end